import { render, staticRenderFns } from "./settingCompany.vue?vue&type=template&id=5c55dab9&scoped=true&"
import script from "./settingCompany.vue?vue&type=script&lang=js&"
export * from "./settingCompany.vue?vue&type=script&lang=js&"
import style0 from "./settingCompany.vue?vue&type=style&index=0&id=5c55dab9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c55dab9",
  null
  
)

export default component.exports